/**
 * Guard a Radix Select's onValueChange so it only forwards one of the field's
 * declared option values (#2010, #2044).
 *
 * Inside a <form>, Radix renders a hidden native <select> beside the trigger
 * (its SelectBubbleInput). When the controlled value changes, an effect assigns
 * the new value to that element and dispatches a native `change`, which comes
 * back through onValueChange. The element's <option>s are contributed by the
 * SelectItems, so when the new value matches none of them -- it arrived before
 * the closed content registered its options (the commit right after mount), or
 * it is not a declared option at all -- the element stays at '' and '' is
 * echoed back as if the operator had chosen it. Writing that into form state
 * erases the value that had just arrived.
 *
 * A real selection is always a SelectItem value, and Radix rejects an
 * empty-string item value, so a payload outside the declared options is never
 * something the operator chose. Dropping it cannot swallow an edit.
 */
export function declaredOptionChange(
  options: ReadonlyArray<{ value: string }> | undefined,
  onChange: (value: string) => void
): (value: string) => void {
  const declared = new Set((options ?? []).map((o) => o.value));
  return (value) => {
    if (declared.has(value)) onChange(value);
  };
}
